import React, { Component } from 'react';

import OTSubscriber from '../../../../src/OTSubscriber'
// import CheckBox from './CheckBox';
import autoBind from 'auto-bind';
export default class Subscriber extends Component {
	constructor(props) {
		super(props);
		autoBind(this);
		this.state = {
			error: null,
			audio: true,
			video: true
		};
	}

	setAudio(audio) {
		this.setState({ audio });
	}

	setVideo(video) {
		this.setState({ video });
	}

	onError(err) {
		this.setState({ error: `Failed to subscribe: ${err.message}` });
	}

	render() {
		return (
			<div className="subscriberSrc">
				{this.state.error ? <div>{this.state.error}</div> : null}
				<OTSubscriber
					session={this.props.session}
					stream={this.props.stream}
					properties={{
						subscribeToAudio: this.state.audio,
						subscribeToVideo: this.state.video
					}}
					onError={this.onError}
				/>
				{/* <CheckBox
					label="Subscribe to Audio"
					initialChecked={this.state.audio}
					onChange={this.setAudio}
				/>
				<CheckBox
					label="Subscribe to Video"
					initialChecked={this.state.video}
					onChange={this.setVideo}
				/> */}
			</div>
		);
	}
}
